exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-4541b4b1] {\n  min-height: 300px;\n}\n.circle[data-v-4541b4b1] {\n  background: #e9ecef;\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n  display: inline-block;\n}\n.done .circle[data-v-4541b4b1] {\n  background: linear-gradient(to right, #cc0000 0%, #ff3737 100%);\n  color: #fff;\n}\n", ""]);

// exports
